import { StyleProps } from "@shared/primitive-components"

export type Status = `error` | `success`

export const root = (status: Status) => (props: StyleProps) => ({
  color: status === `success` ? props.theme.palette.valid : props.theme.palette.error,
})

export const summary = (props: StyleProps) => ({
  marginBottom: props.theme.spacing(2),
})

export const additionalMessage = (additionalMessageOffset: boolean) => (props: StyleProps) => ({
  margin: additionalMessageOffset ? props.theme.spacing(3) : 0,
})

export const buttonsWrap = (props: StyleProps) => ({
  margin: props.theme.spacing(5, 0),
})

export const button = (props: StyleProps) => ({
  height: props.theme.pxToEm(34),
})

export const marginRight = (props: StyleProps) => ({
  marginRight: props.theme.spacing(3),
})
